import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Table,
  Modal,
} from "react-bootstrap";
import UserBuybaner from "./UserBuybaner";
import Header from "./header";
import ExportApi from "../api/ExportApi";
import { useNavigate } from "react-router-dom";
import UserAskBidList from "./UserAskBidList";
import FilterModal from "../shared/FilterModal";
import SortSvg from "../assets/svg/SortSvg"
import {useAuthUser} from "../customHooks/useAuthUser"
import { toast } from "react-toastify";

const UserBuySell = () => {
  const loggedInUser = useAuthUser();
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const [Data, setData] = useState();
  const [initialPageData, setInitialPageData] = useState([]);
  const [Data1, setData1] = useState();
  const [AskBid, setAskBid] = useState();
  const [ask, setAsk] = useState();
  const [Bid, setBid] = useState();
  const [hide, setHide] = useState();
  const [bidStatus, setBidStatus] = useState(false);
  const [askStatus, setAskStatus] = useState(false);
  const [descriptionIndex, setDescriptionIndex] = useState(null);
  const [descriptionindex1, setdescriptionindex1] = useState();
  const [loader, setLoader] = useState(false);
  const [askListOrderBook, setAskListOrderBook] = useState();
  const [bidListOrderBook, setBidListOrderBook] = useState();
  const [sortOrder, setSortOrder] = useState("");
  const [sortColumn, setSortColumn] = useState("");

  // filter State
  const [showFilterModel, setShowFilterModel] = useState(false);
  const [filters, setFilters] = useState({
    brands: [],
    chipset: [],
    condition: [],
    model: [],
    series: [],
  });

  const setDescriptionIndexHandler = (index) => {
    setDescriptionIndex(index);
  };

  const applyFilters = (pageData, filters) => {
    return pageData.filter((item) => {
      return (
        (filters.brands.length === 0 || filters.brands.includes(item.brand)) &&
        (filters.chipset.length === 0 || filters.chipset.includes(item.chipset)) &&
        (filters.condition.length === 0 || filters.condition.includes(item.type)) &&
        (filters.model.length === 0 || filters.model.includes(item.model)) &&
        (filters.series.length === 0 || filters.series.includes(item.series))
      );
    });
  };

  useEffect(() => {
    // Function to handle the click event
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setDescriptionIndex(null); // Close the modal if click is outside
      }
    };

    // Add the event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // On mount: set default filters in localStorage
    localStorage.setItem(
      "compare/filters",
      JSON.stringify(filters)
    );

    // clear filters on unmount
    return () => {
      localStorage.removeItem("compare/filters");
    };
  }, [filters]);

  useEffect(() => {
    const filteredItems = applyFilters(initialPageData, filters);
    setData(filteredItems);
  }, [filters])

  const showOrderBook = (product_id) => {
    setLoader(true);
    ExportApi.showOrderBook(product_id)
      .then((resp) => {
        if (resp?.data.statusCode == 200) {
          setLoader(false);
          setAskListOrderBook(resp?.data.data.askList);
          setBidListOrderBook(resp?.data.data.bidList);
        }
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const hideData = (data) => {
    setHide(data);
  };
  const handleSrech = (e) => {
    if (e == "") {
      setData([...Data1]);
    } else {
      let Filterdata = Data1.filter((val) =>
        val.brand.toLowerCase().includes(e)
      );
      setData([...Filterdata]);
    }
  };

  const handleaskbidlist = (id, i) => {
    if (id) {
      hendleask(id);
      hendlebid(id);
      setAskBid(i);
    } else {
      console.error("ID is undefined");
    }
  };

  const hendleask = (id) => {
    ExportApi.getask(id)
      .then((resp) => {
        setAsk(resp.data.data);
      })
      .catch((err) => console.log(err));
  };

  const hendlebid = (id) => {
    ExportApi.getBid(id)
      .then((resp) => {
        setBid(resp.data.data);
      })
      .catch((err) => console.log(err));
  };

  const handleask = () => {
    if (loggedInUser) {
      setAskStatus(!askStatus);
      setBidStatus(false);
    } else {
      toast.error("Please login first");
    }
  };

  const handleClear = () => {
    if (localStorage.getItem("tokenuser")) {
      handleGetEventlistChange(
        JSON.parse(localStorage.getItem("tokenuser")).id
      );
    } else if (localStorage.getItem("admin")) {
      handleGetEventlistChange(JSON.parse(localStorage.getItem("admin")).id);
    }
  };

  const handleBid = () => {
    if (loggedInUser) {
      setBidStatus(!bidStatus);
      setAskStatus(false);
    } else {
      toast.error("Please login first")
    }
  };

  const handleGetEventlistChange = (id) => {
    ExportApi.GetAllProductUserid(id)
      .then((resp) => {
        setData(resp.data.details);
        setData1(resp.data.details);
      })
      .catch((err) => console.log(err));
  };
  // for the View Your Bid
  const handleGetEventlistChangeAskList = (id) => {
    let Ayyay = [];
    ExportApi.askList(id)
      .then((resp) => {
        for (let index = 0; index < resp.data.data?.length; index++) {
          let obj = {};
          const element = resp.data.data[index];
          obj = { ...element, ...element.productId };
          Ayyay.push(obj);
        }
        setData(Ayyay);
        setData1(Ayyay);
      })
      .catch((err) => console.log(err));
  };

  //for the view your ask
  const handleGetEventlistChangeBidList = (id) => {
    let Ayyay = [];
    ExportApi.getBidList(id)
      .then((resp) => {
        for (let index = 0; index < resp.data.data?.length; index++) {
          let obj = {};
          const element = resp.data.data[index];
          obj = { ...element, ...element.productId };
          Ayyay.push(obj);
        }
        setData(Ayyay);
        setData1(Ayyay);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (localStorage.getItem("Compare")) {
      setData(JSON.parse(localStorage.getItem("Compare")));
      setData1(JSON.parse(localStorage.getItem("Compare")));
      setInitialPageData(JSON.parse(localStorage.getItem("Compare")))
    }
  }, []);
  const CompareOrg = () => {
    if (localStorage.getItem("Compare")) {
      setData(JSON.parse(localStorage.getItem("Compare")));
      setData1(JSON.parse(localStorage.getItem("Compare")));
    }
  };

  //to show the filter Modal
  const handlefilterModal = () => {
    setShowFilterModel(true);
  };

  // clear All Filter
  const clearAllFilters = () => {
    setSortOrder("");
    setSortColumn("");
    setFilters([]);
    localStorage.removeItem("compare/filters")
  };

  const handleSelectAll = (e) => {
    let result = e.target.checked;
    if (result) {
      let data = Data.map((item) => {
        return { ...item, isSelected: true };
      });

      const data3 = Data.map((item) => item._id);
      setData([...data]);
    } else {
      let data = Data.map((item) => {
        return { ...item, isSelected: false };
      });
      setData([...data]);
    }
  };

  const handleSort = (column) => {
    const newSortOrder =
      sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(newSortOrder);

    setData((prevData) => {
      return [...prevData].sort((a, b) => {
        let valA = a[column];
        let valB = b[column];

        // Normalize null/undefined
        if (valA == null) valA = "";
        if (valB == null) valB = "";

        // If both are numbers → numeric sort
        if (!isNaN(valA) && !isNaN(valB)) {
          return newSortOrder === "asc"
            ? Number(valA) - Number(valB)
            : Number(valB) - Number(valA);
        }

        // Otherwise → string sort
        return newSortOrder === "asc"
          ? String(valA).toLowerCase().localeCompare(String(valB).toLowerCase())
          : String(valB).toLowerCase().localeCompare(String(valA).toLowerCase());
      });
    });
  };

  return (
    <div>
      <Header hideData={hideData} />
      <UserBuybaner />

      <Container className="position-relative">
        <Row className="buy-sell-part">
          <Col lg={12} md={12}>
            <div className="bg-dark p-3 d-md-flex align-items-center justify-content-between rounded mt-3">
              <div className="d-flex align-items-center justify-content-between search-box">
                <h4 className="mb-0 text-white me-3 fw-bold text-nowrap">
                  Buy/Sell
                </h4>
                <Form.Control
                  type="search"
                  placeholder="Search GPU"
                  onChange={(e) => handleSrech(e.target.value)}
                />
              </div>
              <div>
                {/* <Button
                  className="bg-light text-black border-0 mb-2 mb-xl-0 text-capitalize"
                  disabled
                >
                  create batch
                </Button>
                <Button
                  className="bg-light text-black border-0 mb-2 mb-xl-0 mx-2 text-capitalize"
                  disabled
                >
                  view batch items
                </Button> */}
                <Button
                  className={`border-0 mb-2 mb-xl-0 text-capitalize ${bidStatus ? "bg-success text-white" : "bg-light text-black"
                    }`}
                  onClick={handleBid}
                >
                  view your bids
                </Button>
                <Button
                  className={`border-0 mb-2 mb-xl-0 mx-2 text-capitalize ${askStatus ? "bg-success text-white" : "bg-light text-black"
                    }`}
                  onClick={handleask}
                >
                  view your asks
                </Button>
                <Button
                  className="bg-light text-black border-0 mb-2 mb-xl-0 px-5 text-capitalize"
                  onClick={() => handlefilterModal()}
                >
                  filter
                </Button>
              </div>
            </div>
            <div className="text-center text-sm-start mt-3">
              <Button
                className="rounded-0 bg-white border text-dark px-5 py-2 fw-bold"
                onClick={() => clearAllFilters()}
              >
                Clear all filters
              </Button>

              {Object.keys(filters).map((filterKey) =>
                filters[filterKey].map((item, index) => (
                  <span
                    key={`${filterKey}-${index}`}
                    className="bg-custom-light border px-3 py-2 text-center ms-2 fw-500 fs-6 d-inline-block"
                  >
                    {
                      filterKey === "condition"
                        ? item === 1
                          ? "New-Retail"
                          : item === 2
                            ? "New(Resale)"
                            : "Used(Tested)"
                        : item
                    }
                    <button
                      type="button"
                      className="bg-none border-0 py-0 text-dark ms-2"
                      onClick={() => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [filterKey]: prevFilters[filterKey].filter(
                            (f) => f !== item
                          ),
                        }));
                      }}
                    >
                      X
                    </button>
                  </span>
                ))
              )}
            </div>
          </Col>
        </Row>
        <div className="table-responsive mb-5">
          <Table bordered striped className="align-middle graphic-table">
            <thead>
              <tr>
                <th className="text-start">
                  {/* <Form.Check
                    className="d-inline me-2"
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e)}
                  />
                  <label>Select All</label> */}
                   Image
                </th>
                <th onClick={() => handleSort("chipset")}>
                  <div className="d-flex align-items-center">
                    Chipset
                    <SortSvg />
                  </div>
                </th>
                <th onClick={() => handleSort("brand")}>
                  <div className="d-flex align-items-center">
                    Brand
                    <SortSvg />
                  </div>
                </th>
                <th onClick={() => handleSort("series")}>
                  <div className="d-flex align-items-center">
                    Series
                    <SortSvg />
                  </div>
                </th>
                <th onClick={() => handleSort("model")}>
                  <div className="d-flex align-items-center">
                    Model
                    <SortSvg />
                  </div>
                </th>
                <th onClick={() => handleSort("highest_bid")}>
                  <div className="d-flex align-items-center">
                    Highest Bid
                    <SortSvg />
                  </div>
                </th>
                <th onClick={() => handleSort("lowest_ask")}>
                  <div className="d-flex align-items-center">
                    Lowest Ask
                    <SortSvg />
                  </div>
                </th>

                <th>
                  <div
                    className="d-flex align-items-center"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Your Ask/Bid

                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {Data &&
                Data.map((val, i) => {
                  return (
                    <tr>
                      <td className="d-flex  align-items-center justify-content-between">

                        <div className="d-flex align-items-center justify-content-between">
                          <div className="buysellimg">
                            <img
                              src={val?.image[0] ?? "https://gpu-wiz.s3.us-west-1.amazonaws.com/socialicons/1737354146756_ls2.png"}
                              style={{
                                cursor: "pointer",
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                objectPosition: "top",
                              }}
                              onClick={() => {
                                navigate(`/product/${val?.slug}`);
                              }}
                              alt="product"
                            />
                          </div>
                          {descriptionIndex === i ? (
                            <Button
                              className="bg-none border-0"
                              onClick={() => setDescriptionIndexHandler(null)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="#0000ff"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  filerule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                            </Button>
                          ) : (
                            <Button
                              className="bg-none border-0"
                              onClick={() => setDescriptionIndexHandler(i)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="#0000ff"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  filerule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                            </Button>
                          )}
                        </div>


                        {descriptionIndex === i ? (
                          <div ref={modalRef} className="modal_custom_">
                            <div className="inner_customModal_one">
                              <h5
                                dangerouslySetInnerHTML={{
                                  __html:
                                    val.description && val.description !== ""
                                      ? val.description
                                      : "No description available",
                                }}
                              ></h5>
                            </div>
                          </div>
                        ) : null}
                      </td>
                      <td>
                        <div style={{ cursor: "default" }}>{val?.chipset}</div>
                      </td>
                      <td>
                        <div style={{ cursor: "default" }}>{val?.brand}</div>
                      </td>
                      <td>
                        <div style={{ cursor: "default" }}>{val?.series}</div>
                      </td>
                      <td>
                        <div
                          className="text-breakdown"
                          style={{ cursor: "default" }}
                          title={val?.model}
                        >
                          {val?.model}
                        </div>
                      </td>

                      <td>
                        {val?.type == 1 ? (
                          " Retail Only"
                        ) : val?.type == 2 ? (
                          <Button
                              className="border bg-danger red-btn"
                              style={{ backgroundColor: "#990000", borderRadius: "50px", padding: "6px 16px" }}
                              onClick={() =>
                                window.open(
                                  "/bidask/" + val?.slug + "/sell",
                                  "_blank"
                                )
                              }
                              disabled={val.highest_bid > 0 ? false : true}
                          >
                            Sell Now -
                            {val.highest_bid > 0
                              ? "$" + val?.highest_bid
                              : "TBD"}
                          </Button>
                          ) : (
                            <Button
                              className="border bg-danger red-btn"
                              style={{ backgroundColor: "#990000", borderRadius: "50px", padding: "6px 16px" }}
                              onClick={() =>
                                window.open(
                                  "/bidask/" + val?.slug + "/sell",
                                  "_blank"
                                )
                              }
                            >
                            Sell Now -
                            {val.highest_bid > 0
                              ? "$" + val?.highest_bid
                              : "TBD"}
                          </Button>
                        )}
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          {val?.type == 1 ? (
                            <Button
                              className="border bg-success green-btn"
                              style={{ backgroundColor: "#225e40", borderRadius: "50px", padding: "6px 16px" }}
                              onClick={() =>
                                window.open(
                                  "/bidask/" + val?.slug + "/buy",
                                  "_blank"
                                )
                              }
                              disabled={
                                val.new_retail_website_price > 0 ? false : true
                              }
                            >
                              Buy Now - ${val?.new_retail_website_price}
                            </Button>
                          ) : (
                            <>
                              <Button
                                className="border bg-success green-btn"
                                style={{ backgroundColor: "#225e40", borderRadius: "50px", padding: "6px 16px" }}
                                onClick={() =>
                                  window.open(
                                    "/bidask/" + val?.slug + "/buy",
                                    "_blank"
                                  )
                                }
                                disabled={val.lowest_ask > 0 ? false : true}
                              >
                                Buy Now -

                                {askStatus
                                  ? val?.askAmount > 0
                                    ? "$" + val?.askAmount
                                    : "TBD"
                                  : val?.lowest_ask > 0
                                    ? "$" + val?.lowest_ask
                                    : "TBD"}

                              </Button>

                              {descriptionindex1 == i ? (
                                <Button
                                  className="bg-none border-0"
                                  onClick={() => {
                                    setdescriptionindex1();
                                    setAskListOrderBook();
                                    setBidListOrderBook();
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#0000ff"
                                    className="bi bi-chevron-down"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      filerule="evenodd"
                                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </Button>
                              ) : (
                                <Button
                                  className="bg-none border-0 arrow-btn-new"
                                  onClick={() => {
                                    showOrderBook(val?._id);
                                    setdescriptionindex1(i);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="#0000ff"
                                    className="bi bi-chevron-down"
                                    viewBox="0 0 16 16"
                                  >
                                    <path
                                      filerule="evenodd"
                                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                    />
                                  </svg>
                                </Button>
                              )}
                            </>
                          )}
                          {descriptionindex1 == i ? (
                            <div
                              class="inner_customModal custom-tab-mode"
                              id="bid_ask_model"
                            >
                              <tr>
                                {loader ? (
                                  <div
                                    className="loader-icon loader-icon1"
                                    style={{
                                      height: "50px",
                                      width: "90px",
                                    }}
                                  >
                                    <i
                                      className="fa-solid fa-spinner fa-spin-pulse"
                                      style={{ marginTop: "80px" }}
                                    ></i>
                                  </div>
                                ) : (
                                  <>
                                    <td>
                                      <div class="table-responsive-sm">
                                        <table class="table table-striped table-bordered table-hover">
                                          <thead>
                                            <tr>
                                              <th>Qty</th>
                                              <th>Bid</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {bidListOrderBook?.length > 0 ? (
                                              bidListOrderBook?.map((item) => (
                                                <tr>
                                                  <td>{item?.quantity}</td>
                                                  <td>${item?.bidAmount}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <td colspan="2">No Bids</td>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="table-responsive-sm">
                                        <table class="table table-striped table-bordered table-hover">
                                          <thead>
                                            <tr>
                                              <th>Qty</th>
                                              <th>Ask</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {askListOrderBook?.length > 0 ? (
                                              askListOrderBook?.map((item) => (
                                                <tr>
                                                  <td>{item?.quantity}</td>
                                                  <td> ${item?.askAmount}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <td colspan="2">No Asks</td>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </>
                                )}
                              </tr>
                            </div>
                          ) : null}
                        </div>
                      </td>
                      <td>
                        {val?.type == 1 ? (
                          "Retail Only"
                        ) : loggedInUser ? (
                          <UserAskBidList
                            productId={val._id}
                            userId={
                              loggedInUser?.id
                            }
                            askListStatus={askStatus}
                            bidListStatus={bidStatus}
                            productSlug={val?.slug}
                          />
                        ) : (
                          <Button
                            className="border bg-none text-dark border-dark"
                            onClick={() =>
                              window.open("/bidask/" + val?.slug, "_blank")
                            }
                          >
                            Place Bid/Ask
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </Container>

      {/* start Filter Model */}
      <Modal
        show={showFilterModel}
        onHide={() => setShowFilterModel(false)}
        backdrop={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <FilterModal
            applyFilters={applyFilters}
            filters={filters}
            setFilters={setFilters}
            filterkey={"compare/filters"}
            pageInitialData={initialPageData}
            setPageData={setData} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UserBuySell;
